import request from '@/config/axios'

export interface TenantVO {
  id: number
  name: string
  contactName: string
  contactMobile: string
  /** 新建时可选：分销邀请码 */
  inviteCode?: string
  status: number
  /** 租户类型：1=内部租户(免购买), 2=外部租户(需购买) */
  tenantType: number
  domain: string
  menuIds: number[]
  username: string
  password: string
  expireTime: Date
  accountCount: number
  /** OSS 配额(bytes)；内部租户为 null=无限；外部可为 0 */
  ossQuota?: number | null
  /** OSS 已用(bytes) */
  ossUsed?: number | null
  createTime: Date
  watermarkEnabled?: boolean
  watermarkText?: string
  watermarkFontSize?: number
  watermarkColor?: string
  watermarkGap?: number
  watermarkOpacity?: number
}

export interface TenantPageReqVO extends PageParam {
  name?: string
  contactName?: string
  contactMobile?: string
  status?: number
  createTime?: Date[]
}

export interface TenantExportReqVO {
  name?: string
  contactName?: string
  contactMobile?: string
  status?: number
  createTime?: Date[]
}

// 查询租户列表
export const getTenantPage = (params: TenantPageReqVO) => {
  return request.get({ url: '/system/tenant/page', params })
}

// 查询租户详情
export const getTenant = (id: number) => {
  return request.get({ url: '/system/tenant/get?id=' + id })
}

// 获取租户精简信息列表
export const getTenantList = () => {
  return request.get({ url: '/system/tenant/simple-list' })
}

// 新增租户
export const createTenant = (data: TenantVO) => {
  return request.post({ url: '/system/tenant/create', data })
}

// 修改租户
export const updateTenant = (data: TenantVO) => {
  return request.put({ url: '/system/tenant/update', data })
}

// 删除租户
export const deleteTenant = (id: number) => {
  return request.delete({ url: '/system/tenant/delete?id=' + id })
}

// 批量删除租户
export const deleteTenantList = (ids: number[]) => {
  return request.delete({ url: '/system/tenant/delete-list', params: { ids: ids.join(',') } })
}

// 导出租户
export const exportTenant = (params: TenantExportReqVO) => {
  return request.download({ url: '/system/tenant/export-excel', params })
}

// 获取当前租户水印配置
export const getTenantWatermark = () => {
  return request.get<{
    enabled: boolean
    text: string
    fontSize: number
    color: string
    gap: number
    opacity: number
  }>({ url: '/system/tenant/get-watermark' })
}
